import { useEffect, useState } from "react";

export const MotivosSelect = ({ name, value, onChange }) => {
  const [state, setState] = useState([]);
  return (
    <select
      className="select-motivo"
      name={name}
      value={value}
      onChange={onChange}
    >
      <option value="CC">Consolidado</option>
      <option value="TE">Tiempo de entrega</option>
      <option value="PR">Precio de la refaccion</option>
      <option value="AB">Atención brindada</option>
      <option value="NN">No se necesitó</option>
    </select>
  );
};
